import useUserAuthStatus from '../useUserAuthStatus'

export default function useSchoolUserAuth() {
  const userAuthHook = useUserAuthStatus()

  const onAuthSuccessful = (userData: any, onSuccess?: () => void) => {
    userAuthHook.loginUser(userData)
    onSuccess?.()
  }

  return {
    onAuthSuccessful,
    logout: userAuthHook.logout,
  }
}
